import { getAccessTokenforResource } from 'owa-tokenprovider';
import { getOrigin } from 'owa-url';

export function getAccessToken(resource: string): Promise<string | undefined> {
    if (resource.toLowerCase().search('outlook') !== -1) {
        resource = getOrigin();
    } else if (
        resource.toLowerCase().search('graph') !== -1 &&
        resource[resource.length - 1] === '/'
    ) {
        resource = resource.substr(0, resource.length - 1);
    }
    return getAccessTokenforResource(resource, 'OwaGroups');
}
